<template>
  <div
    style="
      width: 100%;
      border-radius: 15px;
      overflow: hidden;
      border: 1px solid var(--mainColor-2);
    "
  >
    <!-- path != null ? {lat: 0, lng: 0}: path[0] -->
    <!-- {{ $route.path.includes('cities') }} -->
    <div class="input_wrapper top_label">
      <input
        type="text"
        class="form-control"
        aria-describedby="searchMap"
        placeholder="اختر موقع "
        id="autocomplete_ar"
        @click="getAddress"
      />
    </div>
    <GmapMap
      style="width: 100%; min-height: 300px; max-height: 100%;"
      :zoom="10"
      :center="mapCenter"
      ref="map"
    >
      <!-- @click="generate" -->
      <!-- ========= Draw Path -->
      <!-- <gmap-polyline
        :path.sync="markers"
        :options="{ strokeColor: strokeColor, strokeWeight: 5 }"
      >
      </gmap-polyline> -->

      <!-- v-for="(marker, index) in markers"
        :key="index" -->
      <GmapMarker
        :position="mapCenter"
        :draggable="true"
        @mouseout="markerdraged($event)"
      />
      <!-- @click="removeMarker(index)" -->
    </GmapMap>
  </div>
</template>

<script>
export default {
  props: {
    strokeColor: {
      type: String,
      required: false,
      default: "#1A73E8",
    },
    biggingMarkers: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      markers: [],
      center: [],
      path: [],
      place: null,

      mapCenter: {
        lat: this.biggingMarkers ? this.biggingMarkers.lat : 31,
        lng: this.biggingMarkers ? this.biggingMarkers.lng : 31,
        //   formatted_address: "",
      },
    };
  },

  methods: {
    // START:: GET ADDRESS METHOD
    getAddress() {
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          place.geometry.location.lng();
          place.geometry.location.lat();
          place.formatted_address;
          self.mapCenter.lng = place.geometry.location.lng();
          self.mapCenter.lat = place.geometry.location.lat();
          self.mapCenter.formatted_address = place.formatted_address;
          // self.firestStepRegisterUserData.location.address =
          //     place.formatted_address;
        });
      });

      this.$emit("markersChanged", {
        markers: this.markers,
        mapCenter: this.mapCenter,
      });
    },
    // END: GET ADDRESS METHOD

    // generate(e) {
    //   let marker = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    //   this.center = {
    //     ...marker,
    //   };

    //   this.markers.push(marker);
    //   // this.path.push(marker);

    //   this.$emit("markersChanged", {
    //     markers: this.markers,
    //     mapCenter: this.mapCenter,
    //   });
    // },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => console.log(pos));
        // navigator.geolocation.getCurrentPosition((position) => {
        //   // this.axios({
        //   //   method: "get",
        //   //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
        //   // })
        //   //   .then((res) => {
        //   //     console.log(res.data.results[0].formatted_address);
        //   //   })
        //   //   .catch(() => {});

        //   this.markers = [
        //     {
        //       position: {
        //         lat: position.coords.latitude,
        //         lng: position.coords.longitude,
        //       },
        //     },
        //   ];
        //   this.center = this.markers[0].position;
        //   this.mapCenter.lat = position.coords.latitude;
        //   this.mapCenter.lng = position.coords.longitude;
        // });
      }
    },
    markerdraged(location) {
      this.mapCenter = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.$emit("markersChanged", {
        markers: this.markers,
        mapCenter: this.mapCenter,
      });
    },

    removeMarker(index) {
      this.markers.splice(index, 1);
      this.$emit("markersChanged", {
        markers: this.markers,
        mapCenter: this.mapCenter,
      });
    },

    // markerdraged(index, e) {
    //   let marker = { lat: e.latLng.lat(), lng: e.latLng.lng() };

    //   this.center = {
    //     ...marker,
    //   };

    //   this.$set(this.markers, index, marker);
    //   this.$set(this.path, index, marker);

    //   this.$emit("markersChanged", {
    //     markers: this.markers,
    //     mapCenter: this.mapCenter,
    //   });
    // },
  },

  created() {
    // if (this.biggingMarkers) {
    //   this.markers = this.biggingMarkers;
    // } else {
    //   this.getLocation();
    // }
    // this.path = this.biggingMarkers;
  },
};
</script>
